import { getBrandConfig } from "../../config/brandConfig";

/**
 * Jetons visuels des maquettes « Déclarer un cours, nouveau parcours »
 * (29 octobre 2026). La couleur principale vient de la marque active
 * (brandConfig.colors.primary), le reste est commun aux trois marques.
 */
export const DV2 = {
    pageBg: "#F6F8FB",
    surface: "#FFFFFF",
    border: "#DCE3EC",
    borderSoft: "#EEF1F5",
    text: "#1B2A41",
    textSoft: "#3D4D63",
    /** Textes secondaires : couleur de texte de la marque (brandConfig.colors.text). */
    muted: getBrandConfig().colors.text,
    placeholder: "#8A97A8",
    tint: "#EAF1FA",
    success: "#2E7D4F",
    successBg: "#EAF6EE",
    warning: "#B35A0E",
    warningBg: "#FFF4E5",
    danger: "#B3261E",
    dangerBg: "#FDECEA",
    radius: 18,
    radiusSm: 12,
};

/** Teinte translucide d'une couleur hexadécimale (ex. fond d'un badge). */
export const withAlpha = (hex: string, alpha: number): string => {
    const clean = hex.replace("#", "");
    const full = clean.length === 3 ? clean.split("").map((c) => c + c).join("") : clean;
    const r = parseInt(full.slice(0, 2), 16);
    const g = parseInt(full.slice(2, 4), 16);
    const b = parseInt(full.slice(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
